import { GET_PARAMS } from "./paramHelper";
import { fetchCurrentUser } from "./user";

export const INITIALIZED = "INITIALIZED";
export const INITIALIZATION_ERROR = "INITIALIZATION_ERROR";

export const initialize = token => async dispatch => {
  try {
    const res = await fetch("/api/ping", GET_PARAMS(token));

    if (!res.ok) {
      throw Error(`${res.status} (${res.statusText})`);
    }

    await dispatch({ type: INITIALIZED, message: "success" });

    // If we successfully initialize we should fetch the currentUser
    return dispatch(fetchCurrentUser());
  } catch (err) {
    return dispatch({ type: INITIALIZATION_ERROR, message: err.toString() });
  }
};
